export const C = {
  bg: "#0C0B09",
  bgAlt: "#11100D",
  bgCard: "#161512",
  bgElevated: "#1C1B17",
  green: "#4ADE80",
  greenAccent: "#22C55E",
  greenDark: "#166534",
  greenMuted: "rgba(74,222,128,0.06)",
  greenBorder: "rgba(74,222,128,0.12)",
  cream: "#E8E4DC",
  creamDim: "rgba(232,228,220,0.55)",
  creamMuted: "rgba(232,228,220,0.2)",
  border: "rgba(232,228,220,0.06)",
  borderHover: "rgba(74,222,128,0.25)",
};

export const GRAIN = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E")`;
